import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from './components/Home';
import Footer from './components/Footer';
import Pricing from './components/Pricing';
import AuthCallback from './components/AuthCallback';
import UpdatePassword from './components/UpdatePassword';
import AuthConfirm from './components/AuthConfirm';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

function AppContent() {
  return (
    <div className="app">
      <nav className="nav-bar">
        <div className="nav-container">
          <div className="nav-logo">
            <Link to="/" className="brand-link">
              <img src="/@whinself_logo.png" alt="Whinself - Self-hosted WhatsApp REST API" className="logo" />
              <span className="brand-name">Whinself</span>
            </Link>
          </div>
          <div className="nav-links">
            <Link to="/pricing" className="nav-link">PRICING</Link>
            <a href="https://docs.whinself.app" target="_blank" rel="noopener noreferrer" className="nav-link">HOWTO</a>
            <a href="https://inutil-labs.com/#contact" target="_blank" rel="noopener noreferrer" className="nav-link">CONTACT</a>
          </div>
          <div className="nav-auth">
            <a href="https://docs.whinself.app/docs/tutorials/quick-start" className="nav-button signup">Install App</a>
          </div>
        </div>
      </nav>

      <main className="main-content">
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/auth-callback" element={<AuthCallback />} />
            <Route path="/update-password" element={<UpdatePassword />} />
            <Route path="/auth/confirm" element={<AuthConfirm />} />
            {/* Handle redirects for malformed URLs */}
            <Route path="/auth/confirm/*" element={<AuthConfirm />} />
          </Routes>
        </ErrorBoundary>
      </main>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App; 